<template>
  <section class="promo-grid-section">
    <div class="promo-grid-container">
      <!-- Left Card: AirPods 5 -->
      <div class="promo-card card-airpods">
        <div class="card-bg-layer">
          <img
            src="@/assets/promo-airpods.png"
            alt="AirPods 5"
            class="card-img"
            loading="lazy"
          />
        </div>
        <div class="card-content-overlay dark-overlay">
          <h2 class="card-title">{{ t.promoGrid.airpodsTitle }}</h2>
          <p class="card-tagline" v-html="t.promoGrid.airpodsTagline"></p>
          <p class="card-availability">{{ t.promoGrid.airpodsAvailability }}</p>
          <div class="card-buttons">
            <router-link to="/form" class="btn-pill btn-primary">
              {{ t.promoGrid.airpodsBtn }}
            </router-link>
          </div>
        </div>
      </div>

      <!-- Right Card: MacBook Air -->
      <div class="promo-card card-macbook">
        <div class="card-bg-layer">
          <img
            src="@/assets/promo-macbook.png"
            alt="MacBook Air"
            class="card-img"
            loading="lazy"
          />
        </div>
        <div class="card-content-overlay light-overlay">
          <h2 class="card-title text-dark">{{ t.promoGrid.macbookTitle }}</h2>
          <p class="card-tagline text-dark">{{ t.promoGrid.macbookTagline }}</p>
          <div class="card-buttons">
            <router-link to="/form" class="btn-pill btn-primary">
              {{ t.promoGrid.macbookLearn }}
            </router-link>
            <router-link to="/form" class="btn-pill btn-outline">
              {{ t.promoGrid.macbookBuy }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useI18n } from '@/i18n';

export default {
  name: 'PromoSplitGrid',
  setup() {
    const { t } = useI18n();
    return { t };
  }
}
</script>

<style scoped>
.promo-grid-section {
  width: 100%;
  background-color: #ffffff;
  padding: 10px 10px;
  box-sizing: border-box;
}

.promo-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.promo-card {
  position: relative;
  overflow: hidden;
  height: 580px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: center;
}

.card-macbook {
  background-color: #eaf1f8;
  justify-content: flex-start;
}

/* Background image filling the card */
.card-bg-layer {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 25%;

  display: block;
}

/* Content layer over the graphics */
.card-content-overlay {
  position: relative;
  z-index: 2;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dark-overlay {
  color: #ffffff;
  padding-bottom: 50px;
}

.light-overlay {
  color: #1d1d1f;
  padding-top: 50px;
}

.card-title {
  font-size: clamp(32px, 3.6vw, 40px);
  font-weight: 600;
  letter-spacing: -0.015em;
  margin: 0 0 2px 0;
  font-family: var(--apple-font);
}

.card-tagline {
  font-size: clamp(16px, 1.8vw, 22px);
  font-weight: 400;
  line-height: 1.35;
  margin: 0 0 2px 0;
}

.card-availability {
  font-size: 14px;
  color: #86868b;
  margin: 0 0 16px 0;
}

.text-dark {
  color: #1d1d1f;
}

.card-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 14px;
}

.btn-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  padding: 8px 18px;
  border-radius: 980px;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-primary {
  background-color: #0071e3;
  color: #ffffff;
  border: 1px solid #0071e3;
}

.btn-primary:hover {
  background-color: #0077ed;
  transform: scale(1.02);
}

.btn-outline {
  background-color: transparent;
  color: #0071e3;
  border: 1px solid #0071e3;
}

.btn-outline:hover {
  background-color: #0071e3;
  color: #ffffff;
  transform: scale(1.02);
}

@media (max-width: 900px) {
  .promo-grid-container {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .promo-card {
    height: 480px;
  }
}
</style>
